import styles from './style.postcss';

import React, { Component } from 'react';
import is from 'is_js';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { buildUrl } from 'domain/Api';
import { exporter } from 'domain/Exporter';
import Languages from 'domain/Languages';

import { Button, ConfirmDialog, Dialog, ErrorDialog, log, SolidRadio } from 'omni-common-ui';
import IndividualDevelopmentPlanStatus, { IdpStatus } from 'components/IndividualDevelopmentPlanStatus';

const EXPORT_MIME_TYPE = 'application/pdf';
const DEFAULT_PROGRESS_REPORT_NAME = 'PR';

const LANGUAGE_OPTIONS = [
  { code: Languages.defaultLanguageCode, id: 'language-picker-en' },
  { code: 'zh-CN', id: 'language-picker-zh' },
  { code: 'id-ID', id: 'language-picker-id', label: 'Bahasa' },
  { code: 'vi-VN', id: 'language-picker-vi' },
];

function isCompletedStatus(idpStatus) {
  return (idpStatus || '').toLowerCase() === IdpStatus.COMPLETED.toLowerCase();
}

function buildExportFilename({ studentId, reportName, idpStatus }) {
  const reportNumberMatch = (reportName || '').match(/(\d+)/);
  const progressReportName = reportNumberMatch ?
    `PR${reportNumberMatch[1]}` :
    DEFAULT_PROGRESS_REPORT_NAME;
  const isCompleted = isCompletedStatus(idpStatus);
  const previewSuffix = isCompleted ? '' : '-preview';
  return `${studentId}_${progressReportName}${previewSuffix}.pdf`;
}

class ExportDialog extends Component {
  constructor() {
    super();
    this.state = {
      isExportRequested: false,
      choosedLanguageCode: Languages.defaultLanguageCode,
    };
    this._exportStarted = false;

    this._performExport = this._performExport.bind(this);
  }

  componentDidMount() {
    if (this.props.fetchIdpCheck && this.props.idpId) {
      this.props.fetchIdpCheck(this.props.idpId);
    }
  }

  _close() {
    const { buildRoute, pushRoute } = this.props;
    function redirect(param) {
      pushRoute(buildRoute(param));
    }
    redirect({ mode: '' });
  }

  _performExport() {
    if (this._exportStarted || this.state.isExportRequested) {
      return;
    }

    const { idpId, studentId, reportName, idpStatus } = this.props;

    if (is.falsy(idpId)) {
      log.error('ExportAllHandler is not exporting - idpId is not set!');
      return;
    }

    this._exportStarted = true;
    this.setState({ isExportRequested: true });

    const endpoint = isCompletedStatus(idpStatus) ? 'progress-report-published' : 'progress-report-preview';
    const url = buildUrl(`/student-idps/${idpId}/${endpoint}?languageCode=${this.state.choosedLanguageCode || Languages.defaultLanguageCode}`);

    exporter.get(url,
      buildExportFilename({ studentId, reportName, idpStatus }),
      false,
      EXPORT_MIME_TYPE)
      .then(() => { this._close(); })
      .catch(() => { this.setState({ isExportErrorOccurred: true }); });
  }

  _renderMissingInformation() {
    const { missingInformation } = this.props;
    if (! missingInformation || missingInformation.length === 0) {
      return null;
    }

    return <div className={styles.ExportDialog_missing}>
      <p className={styles.ExportDialog_missingIntro}>Information is still missing:</p>
      <ul className={styles.ExportDialog_missingList}>
        {missingInformation.map((item) =>
          <li key={item}>{item}</li>
        )}
      </ul>
    </div>;
  }

  _renderLanguageOptions() {
    return <div className={styles.ExportDialog_language}>
      <p className={styles.ExportDialog_languageLabel}>Language</p>
      {LANGUAGE_OPTIONS.map(({ code, id, label }) => {
        const isDefault = code === Languages.defaultLanguageCode;
        return <div key={code}
            className={classnames(styles.ExportDialog_languageOption, {
              [styles.__disabled]: ! isDefault,
            })}>
          <SolidRadio name="language-picker"
              id={id}
              value={code}
              isChecked={this.state.choosedLanguageCode === code}
              onChange={() => {}} />
          {label || Languages.getDisplayName(code)}
        </div>;
      })}
    </div>;
  }

  render() {
    if (this.state.isExportErrorOccurred) {
      return <ErrorDialog isOpen
          onConfirmClick={() => { this._close(); }} />;
    }

    if (this.state.isExportRequested) {
      return <ConfirmDialog isOpen
          isLoading
          isButtonless
          title="Exporting reports, please wait">
        <div className={styles.ExportDialog_exportingImmediately} />
      </ConfirmDialog>;
    }

    const { idpStatus } = this.props;

    return <Dialog isOpen
        className={styles.ExportDialog_card}
        onRequestClose={() => this._close()}>
      <div className={styles.ExportDialog}>
        <div className={styles.ExportDialog_header}>
          <div className={styles.ExportDialog_title}>Export Progress Report</div>
          {idpStatus &&
            <IndividualDevelopmentPlanStatus status={idpStatus}
                className={styles.ExportDialog_status} />
          }
        </div>
        {this._renderMissingInformation()}
        {this._renderLanguageOptions()}
        <Button.Container className={styles.ExportDialog_buttons}>
          <Button autoWidth
              type={Button.Type.default}
              className={styles.ExportDialog_button}
              onClick={() => this._close()}>
            Cancel
          </Button>
          <Button autoWidth
              type={Button.Type.primary}
              className={styles.ExportDialog_button}
              onClick={this._performExport}>
            Export
          </Button>
        </Button.Container>
      </div>
    </Dialog>;
  }
}

ExportDialog.propTypes = {
  idpId: PropTypes.string.isRequired,
  studentId: PropTypes.string.isRequired,
  languageCode: PropTypes.string,
  buildRoute: PropTypes.func.isRequired,
  pushRoute: PropTypes.func.isRequired,
  reportName: PropTypes.string,
  idpStatus: PropTypes.string,
  missingInformation: PropTypes.arrayOf(PropTypes.string),
  fetchIdpCheck: PropTypes.func,
};

export default ExportDialog;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/ExportDialog/index.jsx